// extracted by mini-css-extract-plugin
module.exports = {"donationForm":"DonationTable_donationForm__1DCvI","submitButton":"DonationTable_submitButton__1Mvo3"};